import React, { Component } from 'react';
import * as Redux from "react-redux";
import {BrowserRouter as Router, Route, Redirect, Switch} from 'react-router-dom';
import ReactGA from 'react-ga';
// import logo from './logo.svg';
import $ from 'jquery';
import moment from 'moment';

import 'font-awesome/css/font-awesome.min.css';
import './semantic/dist/semantic.min.css';
import './styles/App.css';

import Menu from './components/Menu';
import Dashboard from './components/Dashboard';
import NotFound from './components/NotFound';
import Deny from './components/Deny';
import Login from './components/Login';
import Logout from './components/Logout';
import Loader from './components/Loader';
import OpenTo from './components/OpenTo';
import Tutorials from './components/Tutorials';
import Merge from './components/Merge';
import * as configActions from './actions/configActions';
import * as configHelper from './helpers/configHelper';

window.$ = window.jQuery = $; 
require('semantic-ui/dist/semantic.min.js'); 

class App extends Component {
	constructor(props) {
        super(props);
        const isGoogleAnalyticsEnabled = process.env.NODE_ENV === 'production' 
			&& process.env.REACT_APP_GOOGLE_ANALYTICS_APP_ID && process.env.REACT_APP_GOOGLE_ANALYTICS_APP_ID.length > 0;
		
        this.state = {isGoogleAnalyticsEnabled};
	}
	
	componentWillMount() {
        const {dispatch} = this.props;
        
        dispatch(configActions.startLoadAccountConfig());
	}
  
  	componentWillUnmount() {
    	window.removeEventListener("resize", this.updateDimensions);
  	}

	componentDidMount() {
		const {config} = this.props;
		window.addEventListener("resize", this.updateDimensions);
		this.updateDimensions();

		if (config.isLoaded) {
			this.loadScripts();
		}
  	}

	componentWillReceiveProps(nextProps) {
		if (this.props.config.isLoaded !== nextProps.config.isLoaded) {
            if (nextProps.config.isLoaded)
                this.loadScripts();
		}
	}

	loadScripts() {
		var script1 = document.createElement("script");
		script1.type = 'text/javascript';
    	script1.async = true;
    	script1.innerHTML = "(function(){var uv=document.createElement('script');uv.type='text/javascript';uv.async=true;uv.src='//widget.uservoice.com/v5vAXgnzOLiHLAuJRnZ8Rg.js';var s=document.getElementsByTagName('script')[0];s.parentNode.insertBefore(uv,s)})(); UserVoice = window.UserVoice || []; function showClassicWidget() { UserVoice.push(['showLightbox', 'classic_widget', { mode: 'full', primary_color: '#16191f', link_color: '#007dbc', default_mode: 'support', forum_id: 105089 }])}";
    	
		document.body.appendChild(script1);
	}

  	updateDimensions(){
    	var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
		$('.pusher > .full-height').css('minHeight', h+'px');
  	}

	shouldComponentUpdate(nextProps, nextState) {
        if (this.props.config.isLoaded !== nextProps.config.isLoaded)
            return true;

		return false
    }

  	render() {
        const {isGoogleAnalyticsEnabled} = this.state;
        
	    const PublicRoute = ({ component: Component, roles: roles, account_roles: account_roles, path: path, ...rest }) => (
	    	<Route {...rest} render={(props) => {
				if (window.location.pathname.indexOf("/leads/") === 0) {
					window.location = process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + window.location.pathname.substring(1);
					return <div></div>;
				}

	    		if (isGoogleAnalyticsEnabled && path && path.length > 0) {
	    			const googleAppId = process.env.REACT_APP_GOOGLE_ANALYTICS_APP_ID;

	    			ReactGA.initialize(googleAppId);
	    			ReactGA.set({ page: window.location.pathname + window.location.search });
    				ReactGA.pageview(window.location.pathname + window.location.search);
	    		}

	    		return <Component {...props} />;
	    	}} />
    	);

	    const PrivateRoute = ({ component: Component, roles: roles, account_roles: account_roles, path: path, ...rest }) => (
	    	<Route {...rest} render={(props) => {
	    		if (isGoogleAnalyticsEnabled && path && path.length > 0) {
	    			ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_APP_ID);
	    			ReactGA.set({ page: window.location.pathname + window.location.search });
    				ReactGA.pageview(window.location.pathname + window.location.search);
            }
                
            const ignorePaths = ["/logout"];
            if (ignorePaths.indexOf(path) !== -1) {
               console.log('ignore path', path);
               return <Component {...props} />;
            }
            
				// Forward all leads requests.
				if (window.location.pathname.indexOf("/leads/") === 0) {
					window.location = process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + window.location.pathname.substring(1);
					return <div></div>;
				}

            var canLogin = this.props.config.isLoaded !== false;
            if (canLogin && this.props.config.isLoaded && !this.props.config.is_impersonate 
               && (this.props.config.account.status !== 'A' || this.props.config.user.status !== 'ACT'))
               canLogin = false;

	    		if (canLogin) {
	    			var userRoles = 0;
	    			if (this.props.config.isLoaded && roles && roles.length > 0) {
	    				roles.forEach(role => {
	    					switch(role) {
	    						case "role_manager" : 
									if (this.props.config.user.role_manager || this.props.config.user.role_admin)
										userRoles++;
	    							break;
	    						case "role_share_listing" :
									if (this.props.config.user.role_share_listing || this.props.config.user.role_manager || this.props.config.user.role_admin)
										userRoles++;
	    							break;
	    						default:
	    							break;
	    					}
	    				});
					}
					const isUserRolesValid = !this.props.config.isLoaded || !roles || roles.length === 0 || userRoles === roles.length;

	    			var accountRoles = 0;
	    			if (this.props.config.isLoaded && account_roles && account_roles.length > 0) {
	    				account_roles.forEach(role => {
	    					switch(role) {
								case "is_premium" :
									if (this.props.config.account.is_premium)
	    								accountRoles++;
	    							break;
	    						case "can_access_ygl_network" :
									if (this.props.config.account.can_access_ygl_network)
										accountRoles++;
	    							break;
	    						default:
	    							break;
	    					}
	    				});
					}
					const isAccountRolesValid = !this.props.config.isLoaded || !account_roles || account_roles.length === 0 || accountRoles === account_roles.length;

	    			if (isUserRolesValid && isAccountRolesValid)
		        		return <Component {...props} />;
		        	else
		        		return <Redirect to={{
			            		pathname: '/deny',
			            		state: { from: props.location }
			          		}}/>
	    		} else {
               if (this.props.config.isLoaded && !this.props.config.is_impersonate && (this.props.config.account.status === "E" || this.props.config.account.status === "P") 
                     && configHelper.canManage(this.props.config)) {
                  window.location = process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "billing/payment";
                  return <div></div>;
	    			}
	    			else {
	    				window.location = process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "login";
						return <div></div>;
	    			}
	    		}
	    	}
		    }/>
    	);

      var year = moment().format("Y");
      console.log("REACT_APP_IS_MAINTENANCE_ON", process.env.REACT_APP_IS_MAINTENANCE_ON);

    	return (
			<div className="reactRoot">
				<Loader />
	      		<Router>
	      			<div id="app-container">
                     { parseInt(process.env.REACT_APP_IS_MAINTENANCE_ON)
                        ? <div className="content-wrapper"><h1>Under Maintenance. We'll Be Back Soon.</h1></div>
                        : <div className="pusher">
                           <div>
                              <Menu location={this.props.location} />
                              <div className="content-wrapper">
                                 <Switch>
                                    <PublicRoute exact path="/login" component={Login} />
                                    <PublicRoute exact path="/auth/login" component={Login} />
                                    <PrivateRoute exact path="/" component={Dashboard} />
                                    <PrivateRoute exact path="/dashboard" component={Dashboard} />
                                    <PrivateRoute path="/dashboard/brokers/connect/:encryptId" component={Dashboard} roles={['role_share_listing']} account_roles={['can_access_ygl_network']} />
                                    <PrivateRoute exact path="/landlords/merge" component={Merge} />
                                    <PrivateRoute exact path="/openTo" component={OpenTo} />
                                    <PrivateRoute exact path="/tutorials" component={Tutorials} />
                                    <PublicRoute exact path="/deny" component={Deny} />
                                    <PublicRoute exact path="/notfound" component={NotFound} />
                                    <PrivateRoute exact path="/logout" component={Logout} />
                                    <PublicRoute component={NotFound} />
                                 </Switch>
                                       
                                 <div className="footer ui center aligned segment basic">
                                    <div className="ui fixed bottom sticky to-top-link" >
                                       <a href="javascript:void(0);" onClick={e => {
                                          e.preventDefault();
                                          window.scrollTo(0,0);
                                       }}><i className="fa fa-angle-double-up"></i>Top</a>
                                    </div>
                                          
                                    © {year} YouGotListings. All Rights Reserved. <a href="https://www.yougotlistings.com/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>
                                 </div>
                              </div>
                           </div>
                        </div>
                     }
					</div>
				</Router>
			</div>
    	);
	}
}

export default Redux.connect(
  	(state) => {
    	return state;
  	}
)(App);


// WEBPACK FOOTER //
// ./src/App.js